export let CurrentStateOfBusiness;
(function (CurrentStateOfBusiness) {
  CurrentStateOfBusiness["ExploringBusinessIdea"] = "exploring-business-idea";
  CurrentStateOfBusiness["GettingReadyToLaunch"] = "getting-ready-to-launch";
  CurrentStateOfBusiness["RecentlyLaunched"] = "recently-launched";
  CurrentStateOfBusiness["WantToScale"] = "want-to-scale";
})(CurrentStateOfBusiness || (CurrentStateOfBusiness = {}));